// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__VH7It"};